// extracted by mini-css-extract-plugin
export default {"boxBase":"Box_boxBase__8Y5DV"};